<template>
  <div class="wrapper">
    <nav-top :nav="nav" class="msg-col"></nav-top>
    <el-form class="search" :inline="true" :model="query">
      <el-form-item label="标题:">
        <el-input class="input" placeholder="输入标题" clearable v-model.trim="query.title"></el-input>
      </el-form-item>
      <el-form-item label="日期范围:">
        <el-date-picker
          class="date"
          v-model="date"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dateChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchHandle" class>查询</el-button>
      </el-form-item>
    </el-form>
    <div class="container" v-if="list.length">
      <el-row :gutter="20">
        <el-col :span="12" v-for="(item,index) in list" :key="index">
          <div class="card">
            <h4 :title="item.title">{{item.title}}</h4>
            <ul>
              <li>
                评价时间：
                <span>{{item.startTime}} - {{item.endTime}}</span>
              </li>
              <li>
                评价情况：
                <span>{{item.answerNum}} / {{item.total}}</span>
              </li>
              <li>
                评价状态：
                <span :class="item.status | className">{{item.status==1?'完成':'未完成'}}</span>
              </li>
            </ul>
            <el-button class="button" type="primary" :plain="item.status==1" @click="goDetail(item)">{{item.status==1?'评价详情':'进入评价'}}</el-button>
          </div>
        </el-col>
      </el-row>
      <el-pagination
        :page-size="query.limit"
        :current-page="query.page"
        :total="total"
        layout="total,prev, pager, next, jumper"
        background
        prev-text="上一页"
        next-text="下一页"
        @current-change="handlePagination"
      ></el-pagination>
    </div>
    <div v-else class="b-blank">
      <div class="img"></div>
      <p>暂无内容</p>
    </div>
  </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue';
export default {
  components: {
    NavTop,
  },
  data() {
    return {
      nav: [
        {
          key: 'paperTotal',
          name: '共评价表',
          num: 0,
          img: require('@/assets/img/base/con_pjb.png'),
          status: 0,
        },
        {
          key: 'finishCount',
          name: '已完成',
          num: 0,
          img: require('@/assets/img/base/con_ywc.png'),
          status: 0,
        },
        {
          key: 'unFinishCount',
          name: '未完成',
          num: 0,
          img: require('@/assets/img/base/con_wwc.png'),
          status: 0,
        },
        {
          key: 'reviewedCount',
          name: '已评价',
          num: 0,
          img: require('@/assets/img/base/con_gpjls.png'),
          status: 1,
        },
        {
          key: 'unReviewedCount',
          name: '待评价',
          num: 0,
          img: require('@/assets/img/base/con_dpjls.png'),
          status: 1,
        },
      ],
      date: '',
      query: {
        title: '',
        startTime: '',
        endTime: '',
        page: 1,
        limit: 10,
      },
      total: 0,
      list: []
    };
  },
  mounted() {
    // 头部统计数据
    this.headStatistics()
    this.getList()
  },
  filters: {
    className(val) {
      if (val == 0) {
        return 'nostate';
      } else {
        return 'over';
      }
    },
  },
  methods: {
    dateChange(val) {
      if (val) {
        this.query.startTime = val[0];
        this.query.endTime = val[1];
      } else {
        this.query.startTime = '';
        this.query.endTime = '';
      }
    },
    searchHandle() {
      this.query.page = 1;
      this.query.limit = 10;
      this.getList();
    },
    goDetail(item) {
      this.$router.push({
        name: 'studentEvaluatePeople',
        query: {
          paperId: item.id,
        },
      });
    },
    handlePagination(e) {
      this.query.page = Number(e);
      this.getList();
    },
    getList() {
      this.$get('/evas/paper/student/paperListByStudent', this.query).then(res => {
        console.log(res.result, 'res=00==');
        this.list = res.result.records;
        this.total = res.result.total;
      });
    },
    // 头部统计数据
    headStatistics() {
      this.$get('/evas/paper/student/headStatisticsData').then(res => {
        if(res.success){
          let data = res.result
          this.nav.forEach(n=>{
            n.num = data[n.key]
          })
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  min-height: 800px;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.el-form{
  margin-top: 20px;
}
.date{
  width: 348px;
}
.card {
  margin-bottom: 18px;
  border: 2px solid #f6f6fc;
  box-shadow: 8px 14px 18px 0px rgba(243, 245, 255, 0.72);
  border-radius: 6px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  h4 {
    font-weight: normal;
    font-size: 20px;
    color: #343a52;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ul {
    margin-top: 20px;
    li {
      font-size: 16px;
      color: #a2a4aa;
      line-height: 2;
      span {
        color: #42475e;
      }
      span.nostate {
        color: #4691f3;
      }
      span.doing {
        color: #05b776;
      }
      span.over {
        color: #ff8400;
      }
    }
  }
  .el-button {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
}
.el-pagination {
  text-align: right;
}
</style>
